var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaxExemption(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 27 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Actions / Icons / Tax Exemption") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.50000017,0.5 L54.5000002,0.5 C55.6045697,0.5 56.5000002,1.3954305 56.5000002,2.5 L56.5000002,54.5 C56.5000002,55.6045695 55.6045697,56.5 54.5000002,56.5 L2.50000017,56.5 C1.39543067,56.5 0.500000167,55.6045695 0.500000167,54.5 L0.500000167,2.5 C0.500000167,1.3954305 1.39543067,0.5 2.50000017,0.5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Ticket-Zone-/-Actions",
    transform: "translate(-15.000000, -229.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.540037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Actions-/-Icons-/-Tax-Exemption",
    transform: "translate(0.000000, 204.640387)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#E5E5E5",
    d: "M2.50000017,1 C1.67157304,1 1.00000017,1.67157288 1.00000017,2.5 L1.00000017,54.5 C1.00000017,55.3284271 1.67157304,56 2.50000017,56 L54.5000002,56 C55.3284273,56 56.0000002,55.3284271 56.0000002,54.5 L56.0000002,2.5 C56.0000002,1.67157288 55.3284273,1 54.5000002,1 L2.50000017,1 Z"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TAX",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: -0.14,
    fill: "#747474"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15.6328517,
    y: 33.5
  }, "TAX")))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxExemption);
export default __webpack_public_path__ + "static/media/TaxExemption.d57fd540.svg";
export { ForwardRef as ReactComponent };